import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { CertificatesPage } from '@/features/certificates/components/certificates-page'

export const Route = createFileRoute('/_app/account/certificates')({
  component: CertificatesRoute,
})

function CertificatesRoute(): JSX.Element {
  return <CertificatesPage />
}
